module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"slate__mvpd__verified\" class=\"slate\">\n    <div class=\"slate__wrapper\">\n\n        <div class=\"slate_provider_title\">")
    ; __append(escapeFn( lt_mvpd_verified_heading ))
    ; __append("</div>\n        <div class=\"slate_provider_subtitle\">")
    ; __append(escapeFn( lt_mvpd_verified_sub_heading ))
    ; __append("</div>\n        <div class=\"slate_provider_icon\" id=\"slate_provider_icon\"></div>\n        <div class=\"slate_provider_text\">")
    ; __append(escapeFn( lt_mvpd_verified_text ))
    ; __append("</div>\n        <div class=\"slate_getstarted\">\n            <div id=\"mvpd__getstarted\" class=\"button primary vue-focusable\" tabindex=\"0\" role=\"link\"\n                 aria-label=\"")
    ; __append(escapeFn( lt_mvpd_verified_watch_cta ))
    ; __append("\"\n            >\n                <span class=\"button__text\">\n                    ")
    ; __append(escapeFn( lt_mvpd_verified_watch_cta ))
    ; __append("\n                </span>\n            </div>\n        </div>\n        <div class=\"slate_legal_text\">")
    ; __append( lt_mvpd_verified_legal_text )
    ; __append("</div>\n\n        ")
    ;  if (isAnonOrGhost) { 
    ; __append("\n        <div class=\"slate_provider_divider\"><hr></div>\n\n        <div class=\"slate__title\">")
    ; __append(escapeFn( title ))
    ; __append("</div>\n        <div class=\"slate__description\">\n            <ul class=\"slate__list\">\n                ")
    ; __append( list )
    ; __append("\n            </ul>\n\n            <div class=\"slate__signup__box\">\n                <div role=\"button\" tabindex=\"0\" aria-label=\"")
    ; __append(escapeFn( lt_mvpd_verified_sign_up_cta ))
    ; __append("\" id=\"mvpd__signup\" class=\"button terciary vue-focusable\">\n                    <span class=\"button__text\">\n                        ")
    ; __append(escapeFn( lt_mvpd_verified_sign_up_cta ))
    ; __append("\n                    </span>\n                </div>\n                <div class=\"slate__signup__meta\">\n                    <p>")
    ; __append(escapeFn( lt_mvpd_verified_sign_in_text ))
    ; __append(" <a role=\"button\" href=\"#\" id=\"mvpd__signin\">")
    ; __append(escapeFn( lt_mvpd_verified_sign_in_cta ))
    ; __append("</a></p>\n                    ")
    ;  if(bypassReg) { 
    ; __append("\n                        <p><a href=\"#\" id=\"mvpd__reg-later\" role=\"button\">")
    ; __append(escapeFn( lt_mvpd_verified_register_later ))
    ; __append("</a></p>\n                    ")
    ;  } 
    ; __append("\n                </div>\n            </div>\n        </div>\n        ")
    ;  } 
    ; __append("\n    </div>\n</div>")
  }
  return __output;

}